/*
 * Copyright (c) Nexign, JSC, 2022.
 */
/**
 *
 * @author Evgeniy Naumov
 * @version 1.22.0
 * @since 1.22.0
 */

export const splitUrl = (url: string) => {
    const splitIndex = url.indexOf('?');
    const path = splitIndex >= 0 ? url.slice(0, splitIndex) : url;
    const queryParams = splitIndex >= 0 ? url.slice(splitIndex, url.length) : '';

    return [path, queryParams];
};
